// extracted by mini-css-extract-plugin
export default {"input":"KZrudv","button":"_zLoSl"};